import React from "react";
import classnames from "classnames";
import PropTypes from "prop-types";
import { IoIosCheckmarkCircle } from "react-icons/io";

interface Props {
  name: string;
  chipsArray: [];
  value: any;
  onChange: Function;
  multiple?: boolean;
  badgeColor?: string;
}

function ChipsInput(props: Props) {
  const { chipsArray, name, value, multiple, badgeColor } = props;

  const handleChange = (value: any) => {
    props.onChange && props.onChange(name, value);
  };

  const chipsClasses = (type: any) => {
    return classnames({
      badges: true,
      "mr-md": true,
      "left-icon": multiple
        ? value.find((x) => x.label === type)
        : value === type,
      ["badges-" + badgeColor]: multiple
        ? value.find((x) => x.label === type)
        : value === type,
    });
  };
  return (
    <div className="inline-form-group">
      {chipsArray &&
        chipsArray.map((chip: any, index) => {
          return (
            <div
              key={index}
              className={chipsClasses(chip.label)}
              onClick={() => handleChange(chip)}
            >
              {multiple ? (
                value.find((x) => x.value === chip.value) ? (
                  <IoIosCheckmarkCircle />
                ) : null
              ) : chip.label == value ? (
                <IoIosCheckmarkCircle />
              ) : null}
              {chip.label}
            </div>
          );
        })}
    </div>
  );
}

ChipsInput.defaultProps = {
  name: "",
  chipsArray: [],
  value: null,
  badgeColor: "primary",
};

export default ChipsInput;
